import ReactRenderer from './react/_react-renderer'
import LogosOverview from './react/components/logos/LogosOverview'
import ColorsOverview from './react/components/colors/ColorsOverview'
import TypographyOverview from './react/components/typography/TypographyOverview'
import ImagesOverview from './react/components/images/ImagesOverview'
import DocumentsOverview from 'app/react/components/documents/DocumentsOverview'
import IconsOverview from 'app/react/components/icons/IconsOverview'

import Navigation from "./modules/navigation";
import IntroText from "./modules/intro-text";
import Logos from "./modules/logos";

window.addEventListener('load', () => {
  Navigation()
  IntroText()
  Logos()

  ReactRenderer.registerComponent('LogosOverview', LogosOverview)
  ReactRenderer.registerComponent('ColorsOverview', ColorsOverview)
  ReactRenderer.registerComponent('TypographyOverview', TypographyOverview)
  ReactRenderer.registerComponent('ImagesOverview', ImagesOverview)
  ReactRenderer.registerComponent('DocumentsOverview', DocumentsOverview)
  ReactRenderer.registerComponent('IconsOverview', IconsOverview)
  ReactRenderer.render()
})